import { useTranslation } from 'react-i18next';
import { defaultProps, type FooterProps } from '@/components/footer';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { DialogSlice } from '@/redux/dialog';
import { cn } from '@/utils/helper';
import v1 from '@/components/footer/footer-v1.module.css';
import v2 from '@/components/footer/footer-v2.module.css';

export default function Footer(props: FooterProps) {
  const { links = defaultProps.links } = props;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const domainName = useAppSelector(ConfigSlice.selectors.domainName);
  const selectedKeyword = useAppSelector(ConfigSlice.selectors.selectedKeyword);
  const homepageUrl = useAppSelector(ConfigSlice.selectors.footerHomepageUrl);

  return (
    <footer className={cn(v1.Footer, v2.Footer)} id='footer'>
      <div className={cn(v1.Copyright, v2.Copyright)}>
        <span>
          &copy;&nbsp;{new Date().getFullYear()}&nbsp;{domainName}
        </span>
        {selectedKeyword ? <span>&nbsp;&#124;&nbsp;{selectedKeyword}</span> : null}
      </div>
      <div className={cn(v1.Links, v2.Links)}>
        {homepageUrl ? (
          <a href={homepageUrl} className={cn(v1.Link, v2.Link)}>
            {t('Zur Homepage')}
          </a>
        ) : null}
        {links.map((item) => (
          <button
            key={item.modalName}
            type='button'
            className={cn(v1.Link, v2.Link)}
            onClick={() => dispatch(DialogSlice.actions.openBigTopCenterDialog(item.modalName))}
          >
            {t(item.name)}
          </button>
        ))}
      </div>
    </footer>
  );
}
